import { createContext, FC, ReactNode } from 'react'
import { FilterType } from '@components/Items/types'
import { QUERY_KEYS } from '@components/Items/utils/functions'
import _isArray from 'lodash/isArray'

const FilterContext = createContext<FilterType>({
  query: {},
  updateQuery: (key, val) => Promise.resolve(),
  clearQuery: () => Promise.resolve(),
  itemSearchQuery: '',
  msrpFromQuery: '',
  msrpToQuery: '',
  conditionList: [],
  locationList: {},
  itemCategoriesList: {},
  pickupDateList: [],
  endDateList: [],
  pageIdQuery: 1,
  conditionQuery: undefined,
  categoryJsonQuery: {},
  locationQuery: undefined,
  pickupDateQuery: undefined,
  endDateQuery: undefined,
  bidftaPlusQuery: undefined,
  pickupDaysQuery: undefined,
  numberOfUniqueBiddersQuery: undefined,
  isLoading: false,
})

const FilterProvider: FC<FilterType & { children?: ReactNode }> = ({
  updateQuery,
  clearQuery,
  query,
  conditionList,
  locationList,
  itemCategoriesList,
  pickupDateList,
  endDateList,
  isLoading,
  children,
}) => {
  const conditionQuery = query[QUERY_KEYS.ITEM_CONDITION_IDS]
  const locationQuery = query[QUERY_KEYS.LOCATIONS]
  const categoryStringQuery = query[QUERY_KEYS.CATEGORIES]
  const categoryJsonQuery = (
    categoryStringQuery
      ? JSON.parse(
          _isArray(categoryStringQuery)
            ? decodeURIComponent(categoryStringQuery[0])
            : decodeURIComponent(categoryStringQuery)
        )
      : {}
  ) as { [category1: string]: string[] }
  const pickupDateQuery = query[QUERY_KEYS.PICKUP_DATES]
  const endDateQuery = query[QUERY_KEYS.END_DATE]
  const itemSearchQuery = query[QUERY_KEYS.ITEM_SEARCH_KEYWORDS]
  const msrpFromQuery = query[QUERY_KEYS.MSRP_FROM]
  const msrpToQuery = query[QUERY_KEYS.MSRP_TO]
  const pickupDaysQuery = query[QUERY_KEYS.PICKUP_DAYS]
  const numberOfUniqueBiddersQuery = query[QUERY_KEYS.NUMBER_OF_UNIQUE_BIDDERS]
  const pageIdQuery = query.pageId || 1
  const bidftaPlusQuery = query[QUERY_KEYS.BIDFTA_PLUS]

  return (
    <FilterContext.Provider
      value={{
        pageIdQuery,
        itemSearchQuery,
        msrpFromQuery,
        msrpToQuery,
        pickupDaysQuery,
        updateQuery,
        clearQuery,
        query,
        locationList,
        itemCategoriesList,
        conditionList,
        pickupDateList,
        endDateList,
        locationQuery,
        categoryJsonQuery,
        conditionQuery,
        pickupDateQuery,
        endDateQuery,
        bidftaPlusQuery,
        numberOfUniqueBiddersQuery,
        isLoading,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export { FilterContext, FilterProvider }
